module.exports = __webpack_public_path__ + "media/images/lb/993-edf124894b1d34f456070d0a9d402814.svg";